import { defineComponent, ref } from 'vue';
import { Image2 } from '@hems/component';
export default defineComponent({
    name: 'ApplianceUnregistered',
    components: {
        Image2,
    },
    setup() {
        const guideContents = ref(null);
        const onScrollRight = () => {
            if (guideContents.value) {
                guideContents.value.scrollLeft = guideContents.value.offsetWidth;
            }
        };
        const onScrollLeft = () => {
            if (guideContents.value) {
                guideContents.value.scrollLeft = 0;
            }
        };
        return {
            onScrollRight,
            onScrollLeft,
            guideContents,
        };
    },
});
